import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../state/store";

export interface UtilState {
  isNavCollapsed: boolean;
}

const initialState: UtilState = {
  isNavCollapsed: false,
};

export const utilSlice = createSlice({
  name: "util",
  initialState,
  reducers: {
    setIsNavCollapsed: (state, action: PayloadAction<{ isNavCollapsed: boolean }>) => {
      state.isNavCollapsed = action.payload.isNavCollapsed;
    },
    collapseNav: (state) => {
      state.isNavCollapsed = true;
    },
    openNav: (state) => {
      state.isNavCollapsed = false;
    },
  },
});

export const { setIsNavCollapsed, collapseNav, openNav } = utilSlice.actions;

export const selectIsNavCollapsed = (state: RootState) => state.util.isNavCollapsed;

export const utilReducer = utilSlice.reducer;
